/* eslint-disable jsx-a11y/anchor-is-valid */
import './notify-modal.less';
import { FC } from 'react';
import { SvgIcon, Modal, Button } from '@/components';

export interface NotifyModalProps {
  visible: boolean;
  onClose?: () => void;
}

const NotifyModal: FC<NotifyModalProps> = ({
  visible = false,
  onClose = () => {},
}) => {
  return (
    <Modal visible={visible} className="notify-modal tc">
      <SvgIcon
        className="cursor"
        style={{ fill: '#0476EB' }}
        name="upload"
        width="145"
        height="145"
      />
      <p className="title">通知</p>
      <p className="desc">
        此小部件所属的 App 被下架，请保证该版本 App
        在小米应用商店正常上线之后，可重新提交小部件
      </p>
      <Button
        className="dbi w100"
        type="primary"
        href={'https://dev.mi.com/distribute'}
      >
        应用商店
      </Button>
      <Button
        className="mt20 dbi w100"
        onClick={() => {
          onClose && onClose();
        }}
      >
        返回
      </Button>
      <div className="tip-box">
        {/* <p className="tip">
          查看
          <a
            className="mag-link"
            target="_blank"
            rel="noreferrer"
            href="https://dev.mi.com/console/doc/detail?pId=2232"
          >
            《下架应用申诉线上化操作指南》
          </a>
        </p> */}
      </div>
    </Modal>
  );
};
export default NotifyModal;
